import React, { useState, useRef } from 'react'
import { Spinner } from 'react-bootstrap'
import '../Login/Login.css'

const OTP_LENGTH = 4

const OTPInput = ({ onComplete, onResend, email, error, loading, hideFallbackText = false }) => {
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(''))
  const inputRefs = useRef([])

  const handleChange = (index, value) => {
    if (value && !/^\d$/.test(value)) return
    const newOtp = [...otp]
    newOtp[index] = value
    setOtp(newOtp)

    if (value && index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1]?.focus()
    }
    if (value && index === OTP_LENGTH - 1) {
      const code = newOtp.join('')
      if (code.length === OTP_LENGTH) {
        onComplete(code)
      }
    }
  }

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus()
    }
    if (e.key === 'Enter') {
      const code = otp.join('')
      if (code.length === OTP_LENGTH) {
        onComplete(code)
      }
    }
  }

  const handlePaste = (e) => {
    e.preventDefault()
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, OTP_LENGTH)
    if (pastedData) {
      const newOtp = Array(OTP_LENGTH).fill('')
      pastedData.split('').forEach((char, i) => {
        newOtp[i] = char
      })
      setOtp(newOtp)
      if (pastedData.length === OTP_LENGTH) {
        onComplete(pastedData)
      } else {
        inputRefs.current[pastedData.length]?.focus()
      }
    }
  }

  return (
    <div className="otp-section">
      {email && (
        <div className="login-message">
          We've sent a login code to <b>{email}</b>
        </div>
      )}
      <div className="otp-container">
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            className={`otp-input ${error ? 'otp-input-error' : ''}`}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={index === 0 ? handlePaste : undefined}
            autoFocus={index === 0}
            aria-label={`Digit ${index + 1}`}
          />
        ))}
      </div>
      {error && <div className="otp-error-message">Invalid or expired code. Please try again.</div>}
      {loading && (
        <div className="w-100 text-center mt-2">
          <Spinner size="sm" animation="border" />
        </div>
      )}
      {!hideFallbackText && <div className="otp-fallback-text">Or check your email for a login link</div>}
    </div>
  )
}

export default OTPInput
